<script>
	import { Offcanvas, Col, Row } from "@sveltestrap/sveltestrap";
	import { canvasOpen, isEvLogOpen } from "../../store/store";
	import FontAwesomeIcon from "src/components/FontAwesomeIcon/FontAwesomeIcon.svelte";
	import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
	import Modal from "../../views/EvManagement/Manage/ModalEvLogs.svelte";

	export let messages;
	let open;
	canvasOpen.subscribe((val) => {
		open = val;
	});

	const toggle = () => {
		canvasOpen.set(false);
	};

	let modalOpen = false;

	function toggleModalUpdate() {
		modalOpen = false;
		modalOpen = true;
	}
</script>

<div class="offcanvas-container">
	<Offcanvas
		isOpen={open}
		scroll
		backdrop={false}
		placement="top"
		style="background-color:#464646; color:white; height:69px;"
	>
		<Row class="mx-4">
			<Col>
				<Row>
					<Col class="d-flex align-items-center">
						<div class="canvas-icon">
							<FontAwesomeIcon icon={faInfoCircle} />
						</div>
						<div class="mt-1 ms-3">
							<span>{messages}</span>
						</div>
					</Col>
				</Row>
			</Col>

			<Col class="d-flex justify-content-end">
				<button class="text-button pe-4" on:click={toggleModalUpdate}
					>View recent updates</button
				>
				<button class="text-button" on:click={toggle}>DISMISS</button>
			</Col>
		</Row>
	</Offcanvas>
</div>

{#if !!modalOpen}
	<Modal showModal={!!modalOpen} />
{/if}

<style>
	.canvas-icon {
		width: 24px;
		height: 24px;
	}

	.canvas-icon :global(svg) {
		width: 100%;
		height: 100%;
	}

	.text-button {
		border: none;
		background-color: transparent;
		color: #c2e9ff;
	}

	.offcanvas-container {
		position: relative;
		/* Other styles to control the size and positioning of the container */
	}
</style>
